import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { HeadComponent } from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import LocalizedNavLink from '../../router/LocalizedNavLink';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';

import './NotFoundPage.scss';

export class NotFoundPage extends React.Component {
    render() {
        const { i18n } = this.props;
        return (
            <main className="conteneur conteneur-mobile" id="p-notfound">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.NOT_FOUND_PATH}`}
                    noIndex
                />
                <h1>{i18n.h1}</h1>
                <p>
                    {i18n.text1}{' '}
                    <LocalizedNavLink to={PATH.HOME_PATH} name="notFoundPage-toHome">
                        {i18n.text2}
                    </LocalizedNavLink>
                    {i18n.text3}
                </p>
            </main>
        );
    }
}

NotFoundPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.PAGE_404
    };
}

export default withTemplate(connect(mapStateToProps)(NotFoundPage), PrimaryTemplate, {
    hideBreadcrumb: true
});



// WEBPACK FOOTER //
// ./src/components/pages/notfound/NotFoundPage.js